import { SolValidationMessage } from './sol-validation-message';

/**
 * Build object to easily create a validation result within a validator.
 */
export class SolValidationBuilder {
  private readonly messages: SolValidationMessage[] = [];

  public build(): SolValidationMessage[] {
    return this.messages;
  }

  /**
   * Add a validation message to the validation result.
   */
  public add(message: SolValidationMessage) {
    this.messages.push(message);
  }

  /**
   * Add a list of validation messages to the validation result.
   */
  public addAll(messages: SolValidationMessage[]) {
    this.messages.push(...messages);
  }
}
